import React from "react";
import "../../../fonts/font.css";

import feeIcon1 from "../../../images/fee_icon_1.png";
import feeIcon2 from "../../../images/fee_icon_2.png";
import feeIcon3 from "../../../images/fee_icon_3.png";

import { feeGenerate } from "../nav/data";

import {
  SolutionContentsWrapper,
  LineWrapper,
  Title,
  TitleIcon,
  Cost,
  IncreaseBadges,
  DecreaseBadges,
  SameBadges,
  NewBadges,
} from "../solution/solution_components.js";

export function FeeSolution({ src, iconHeight, iconWidth }) {

  var weekdayFee = sessionStorage.getItem("weekdayFee");
  var weekendFee = sessionStorage.getItem("weekendFee");
  var dayPassFee = sessionStorage.getItem("dayPassFee");
  var monthPassFee = sessionStorage.getItem("monthPassFee");


    var decreaseNum ;
    var increaseNum ;

  return (
    <SolutionContentsWrapper>
      <LineWrapper>
        <Title>
          평일 <span> 1시간 요금제 </span>
        </Title>
        <Cost marginLeft="80"> {feeGenerate[0]}원 </Cost>
        { // 데이터 입력무조건 있으니 비교로 바로 넘어감
          weekdayFee==feeGenerate[0] ? ( // 동일한 값이면
            <SameBadges type="요금" /> // 동결 배지
          ) : weekdayFee < feeGenerate[0] ? ( // 증가한 값이면
            <IncreaseBadges
              type="요금"
              increaseNum={Math.floor((feeGenerate[0] / weekdayFee - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="요금" decreaseNum={Math.floor((weekdayFee / feeGenerate[0] - 1) * 100)} /> //감소배지
          )
        }
      </LineWrapper>
      <LineWrapper>
        <Title>
          주말 <span> 1시간 요금제 </span>
        </Title>
        <Cost marginLeft="80"> {feeGenerate[1]}원 </Cost>
        { // 데이터 입력무조건 있으니 비교로 바로 넘어감
          weekendFee==feeGenerate[1] ? ( // 동일한 값이면
            <SameBadges type="요금" /> // 동결 배지
          ) : weekendFee < feeGenerate[1] ? ( // 증가한 값이면
            <IncreaseBadges
              type="요금"
              increaseNum={Math.floor((feeGenerate[1] / weekendFee - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="요금" decreaseNum={Math.floor((weekendFee / feeGenerate[1] - 1) * 100)} /> //감소배지
          )
        }
      </LineWrapper>
      <LineWrapper>
        <TitleIcon src={feeIcon3} iconHeight="15" iconWidth="25" />
        <Title>일 정기권</Title>
        <Cost marginLeft="100"> {feeGenerate[2]}원 </Cost>
        {dayPassFee !== ""? ( // 데이터 입력이 없었으면
          dayPassFee==feeGenerate[2] ? ( // 동일한 값이면
            <SameBadges type="요금" /> // 동결 배지
          ) : dayPassFee < feeGenerate[2] ? ( // 증가한 값이면
            <IncreaseBadges
              type="요금"
              increaseNum={Math.floor((feeGenerate[2] / dayPassFee - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="요금" decreaseNum={Math.floor((dayPassFee / feeGenerate[2] - 1) * 100)} /> //감소배지
          )
        ) : (dayPassFee === "0" ?
        (<NewBadges /> // 신규 배지
      ) : (<NewBadges />))}
      </LineWrapper>
      <LineWrapper>
        <TitleIcon src={feeIcon2} iconHeight="15" iconWidth="15" />
        <Title>월 정기권</Title>
        <Cost marginLeft="90"> {feeGenerate[3]}원 </Cost>
        {monthPassFee !== "" ? ( // 데이터 입력이 없었으면
          monthPassFee==feeGenerate[3] ? ( // 동일한 값이면
            <SameBadges type="요금" /> // 동결 배지
          ) : monthPassFee < feeGenerate[3] ? ( // 증가한 값이면
            <IncreaseBadges
              type="요금"
              increaseNum={Math.floor((feeGenerate[3] / monthPassFee - 1) * 100)}
            ></IncreaseBadges> // 상승배지
          ) : (
            <DecreaseBadges type="요금" decreaseNum={Math.floor((monthPassFee / feeGenerate[3] - 1) * 100)} /> //감소배지
          )
        ) : (monthPassFee === "0" ?
          (<NewBadges /> // 신규 배지
        ) : (<NewBadges />))} 
      </LineWrapper>
    </SolutionContentsWrapper>
  );
}
